/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Attention(props) {
    return (
        <SvgIcon {...props}>
            <path d="M6.5,0.5C2.91,0.5,0,3.411,0,7s2.91,6.5,6.5,6.5S13,10.59,13,7S10.09,0.5,6.5,0.5z M7.242,11.312H5.571 v-1.254h1.671V11.312z M7.242,8.805H5.571v-5.85h1.671V8.805z" />
        </SvgIcon>
    );
}

Attention.defaultProps = {
    viewBox: '0 0 13 16'
};

export default Attention;
